import styled from 'react-emotion';

export const Gap = styled.div`
  height: 20px;
`;

export const GapPageBreaker = styled(Gap)`
  page-break-after: always;
  @media print {
    height: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/gap.jsx